export default __webpack_public_path__ + "static/media/euroset.f25c2fef.svg";